/* global BigInt */
import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseEth = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const purchaseEth = useCallback(
    async (
      min,
      amount,
      postApiRes,
      id,
      balance,
      stakeIndex,
      index,
      insurancePer
    ) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      let nd;
      if (index) {
        const percent = parseFloat(amount) * insurancePer;
        const value = parseFloat(amount) + percent;
        const fixed = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      } else {
        const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      }

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      /* viem is strict about ABI types where web3.js was not:
         uint256 needs a bigint, uint8/uint32 need a number. */
      const args = [
        postApiRes.code, // string   code
        Number(id), // uint32   round
        BigInt(postApiRes.deadline), // uint256  deadline
        minvalue, // uint256  minAmountToken
        (stakeIndex ?? []).map((i) => BigInt(i)), // uint256[] indexes
        postApiRes?.agentsAddresses ?? [], // address[] leaders
        (postApiRes?.agentsPercentages ?? []).map((p) => BigInt(p)), // uint256[] percentages
        Number(postApiRes?.v), // uint8    v
        postApiRes?.r, // bytes32  r
        postApiRes?.s, // bytes32  s
      ];

      console.log(nd, ...args, "purchaseEth params");

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithETH",
          args,
          value: nd,
        });

        console.log("PurchaseEth tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseEth confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseEth error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseEth };
};

export default usePurchaseEth;
